import { apiClient } from '../client';
import { 
  InterestGroup, 
  CreateInterestGroupDto, 
  UpdateInterestGroupDto, 
  ReorderGroupsDto,
  AddInterestToGroupDto 
} from '../../types';

export const interestGroupService = {
  // Get all interest groups
  getAllGroups: async (): Promise<InterestGroup[]> => {
    const response = await apiClient.get('/interest-groups');
    return response.data;
  },

  // Get a single interest group by ID
  getGroupById: async (id: string): Promise<InterestGroup> => {
    const response = await apiClient.get(`/interest-groups/${id}`);
    return response.data;
  },

  // Create a new interest group
  createGroup: async (data: CreateInterestGroupDto): Promise<{ message: string; data: InterestGroup }> => {
    const response = await apiClient.post('/interest-groups', data);
    return response.data;
  },

  // Update an interest group
  updateGroup: async (id: string, data: UpdateInterestGroupDto): Promise<{ message: string; data: InterestGroup }> => {
    const response = await apiClient.put(`/interest-groups/${id}`, data);
    return response.data;
  },

  // Delete an interest group (soft delete)
  deleteGroup: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/interest-groups/${id}`);
    return response.data;
  },

  // Add an interest to a group
  addInterestToGroup: async (groupId: string, data: AddInterestToGroupDto): Promise<{ message: string; data: InterestGroup }> => {
    const response = await apiClient.post(`/interest-groups/${groupId}/interests`, data);
    return response.data;
  },

  // Remove an interest from a group
  removeInterestFromGroup: async (groupId: string, interestId: string): Promise<{ message: string; data: InterestGroup }> => {
    const response = await apiClient.delete(`/interest-groups/${groupId}/interests/${interestId}`);
    return response.data;
  },

  // Reorder groups
  reorderGroups: async (updates: ReorderGroupsDto[]): Promise<{ message: string; data: InterestGroup[] }> => {
    const response = await apiClient.put('/interest-groups/reorder', updates);
    return response.data;
  },

  // Reorder interests within a group
  reorderInterestsInGroup: async (groupId: string, updates: Array<{ interestId: string; order: number }>): Promise<{ message: string; data: InterestGroup }> => {
    const response = await apiClient.put(`/interest-groups/${groupId}/reorder-interests`, updates);
    return response.data;
  },
};